var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3C11 2.44772 11.4477 2 12 2C17.5228 2 22 6.47715 22 12C22 12.5523 21.5523 13 21 13H12C11.4477 13 11 12.5523 11 12V3ZM13 4.06189V11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189ZM8.89551 3.49049C9.1413 3.98507 8.93961 4.58525 8.44503 4.83103C5.80844 6.14131 4 8.86038 4 12C4 16.4183 7.58172 20 12 20C15.1396 20 17.8587 18.1916 19.169 15.555C19.4148 15.0604 20.0149 14.8587 20.5095 15.1045C21.0041 15.3503 21.2058 15.9505 20.96 16.445C19.3249 19.7353 15.9278 22 12 22C6.47715 22 2 17.5228 2 12C2 8.07218 4.26468 4.67514 7.55497 3.04001C8.04955 2.79422 8.64973 2.99591 8.89551 3.49049Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.32bb59879384f573483c122e0722b8f2.svg";
export { ForwardRef as ReactComponent };